import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonRow,
} from "@ionic/react";
import React from "react";

const Home: React.FC = () => {
  let srcImg = process.env.PUBLIC_URL + "/imgs/ENEATEST_GRANDE.jpg";
  return (
    <IonPage>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow className="ion-text-center">
            <IonCol size="12">
              <img style={{ width: "100vh" }} src={srcImg} alt="home"></img>
            </IonCol>
            <IonCol>
              <IonButton size="large" routerLink="/test">
                Ir al test
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Home;
